import React from 'react';

import { RootButton } from './style';

export function Root(props) {
  return (
    <RootButton {...props} />
  )
}